import { FaWordpress, FaShopify, FaWix, FaSquarespace } from 'react-icons/fa';
import { Settings } from 'lucide-react';

export function WordPressIcon({ className = "w-6 h-6", ...props }) {
  return <FaWordpress className={className} color="#21759B" {...props} />;
}

export function ShopifyIcon({ className = "w-6 h-6", ...props }) {
  return <FaShopify className={className} color="#96BF48" {...props} />;
}

export function WixIcon({ className = "w-6 h-6", ...props }) {
  return <FaWix className={className} color="#0C6EFC" {...props} />;
}

export function SquarespaceIcon({ className = "w-6 h-6", ...props }) {
  return <FaSquarespace className={className} color="#222222" {...props} />;
}

export function CustomCmsIcon({ className = "w-6 h-6", ...props }) {
  return <Settings className={className} color="#D97706" {...props} />;
}

const PlatformIcons = {
  wordpress: WordPressIcon,
  shopify: ShopifyIcon,
  wix: WixIcon,
  squarespace: SquarespaceIcon,
  custom: CustomCmsIcon,
};

export default PlatformIcons;
